module.exports = __webpack_public_path__ + "static/wl_logo2x-1444d2f7308c378096bce24a8f80c79d.png";